import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import DashboardEvent from "../event/DashboardEvent";

export default class DashboardNavigateCommand extends AbstractCommand{
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(evt) {
        this._handleCloseBound = this._handleClose.bind(this);
        this._dispatcher.addEventListener(DashboardEvent.CLOSE_SCREEN_REQUEST, this._handleCloseBound);

        this._screenSkin = this.openScreen(SkinKeyRegistry.DASHBOARD_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });
    }


    _handleClose() {
        this._dispatcher.removeEventListener(DashboardEvent.CLOSE_REQUEST, this._handleCloseBound);
        this.closeScreen(this._screenSkin);
    }
}